import { Bell, Loader, Save, Settings, Shield } from 'lucide-react';
import { useEffect, useState } from 'react';
import { API_ENDPOINTS, buildApiUrl } from '../config/api.js';
import { useAuth } from '../contexts/AuthContext.jsx';

const Ajustes = () => {
  const { authenticatedFetch } = useAuth();
  const [bikePartialDepositPercent, setBikePartialDepositPercent] = useState(20);
  const [loadingSettings, setLoadingSettings] = useState(true);
  const [savingSettings, setSavingSettings] = useState(false);
  const [settingsError, setSettingsError] = useState(null);
  const [settingsOk, setSettingsOk] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoadingSettings(true);
        const res = await authenticatedFetch(buildApiUrl(`${API_ENDPOINTS.SETTINGS}/bike-partial-deposit`));
        const data = await res.json();
        if (!cancelled && data.success && data.data?.bikePartialDepositPercent != null) {
          setBikePartialDepositPercent(data.data.bikePartialDepositPercent);
        }
      } catch (e) {
        if (!cancelled) console.error(e);
      } finally {
        if (!cancelled) setLoadingSettings(false);
      }
    })();
    return () => { cancelled = true; };
  }, [authenticatedFetch]);

  const saveBikePartialDeposit = async () => {
    setSettingsError(null);
    setSettingsOk(false);
    setSavingSettings(true);
    try {
      const res = await authenticatedFetch(buildApiUrl(`${API_ENDPOINTS.SETTINGS}/bike-partial-deposit`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bikePartialDepositPercent }),
      });
      const data = await res.json();
      if (!data.success) {
        setSettingsError(data.message || 'No se pudo guardar');
        return;
      }
      if (data.data?.bikePartialDepositPercent != null) {
        setBikePartialDepositPercent(data.data.bikePartialDepositPercent);
      }
      setSettingsOk(true);
    } catch (e) {
      setSettingsError(e.message || 'Error de red');
    } finally {
      setSavingSettings(false);
    }
  };

  return (
    <div className="content-page">
      <div className="page-header">
        <h1>Configuración del Sistema</h1>
      </div>

      <div className="settings-container">
        <div className="settings-section">
          <h2>
            <Settings size={20} />
            Reservas de bicicletas — pago parcial
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '16px', fontSize: '14px' }}>
            Porcentaje aplicado al total para calcular el <strong>primer anticipo en euros enteros</strong> (redondeo al entero más cercano).
            Ej.: total 93,57 € y 20 % → 19 € de primer pago.
          </p>
          <div className="setting-item" style={{ alignItems: 'flex-end', flexWrap: 'wrap', gap: '12px' }}>
            <div className="setting-info">
              <h3>Anticipo inicial (%)</h3>
              <p>Valor entre 1 y 100. Se puede sobrescribir por reserva en el formulario de alta.</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {loadingSettings ? (
                <Loader size={20} className="spin" />
              ) : (
                <>
                  <input
                    type="number"
                    min={1}
                    max={100}
                    step={1}
                    value={bikePartialDepositPercent}
                    onChange={(e) => setBikePartialDepositPercent(parseInt(e.target.value, 10) || 1)}
                    className="setting-select"
                    style={{ width: '88px' }}
                  />
                  <span>%</span>
                  <button
                    type="button"
                    className="btn-primary"
                    onClick={saveBikePartialDeposit}
                    disabled={savingSettings}
                  >
                    {savingSettings ? <Loader size={16} className="spin" /> : <Save size={16} />}
                    Guardar
                  </button>
                </>
              )}
            </div>
          </div>
          {settingsError && (
            <p style={{ color: '#b91c1c', fontSize: '14px', marginTop: '8px' }}>{settingsError}</p>
          )}
          {settingsOk && (
            <p style={{ color: '#15803d', fontSize: '14px', marginTop: '8px' }}>Guardado correctamente.</p>
          )}
        </div>

        <div className="settings-section">
          <h2>
            <Bell size={20} />
            Notificaciones
          </h2>
          <div className="setting-item">
            <div className="setting-info">
              <h3>Notificaciones por email</h3>
              <p>Recibir notificaciones por correo electrónico</p>
            </div>
            <label className="toggle">
              <input type="checkbox" defaultChecked />
              <span className="slider"></span>
            </label>
          </div>
          <div className="setting-item">
            <div className="setting-info">
              <h3>Notificaciones push</h3>
              <p>Recibir notificaciones en tiempo real</p>
            </div>
            <label className="toggle">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h2>
            <Shield size={20} />
            Seguridad
          </h2>
          <div className="setting-item">
            <div className="setting-info">
              <h3>Autenticación de dos factores</h3>
              <p>Activar verificación adicional de seguridad</p>
            </div>
            <label className="toggle">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </div>
          <div className="setting-item">
            <div className="setting-info">
              <h3>Sesión automática</h3>
              <p>Mantener sesión iniciada</p>
            </div>
            <label className="toggle">
              <input type="checkbox" defaultChecked />
              <span className="slider"></span>
            </label>
          </div>
        </div>

        {/* <div className="settings-section">
          <h2>
            <Palette size={20} />
            Apariencia
          </h2>
          ...
        </div> */}
      </div>
    </div>
  );
};

export default Ajustes;
